import React from 'react';
import ReportingSalesTicketsPage from '../components/ReportingSalesTicketsPage';

const ReportingSalesTicketsApp = (props) => (
  <ReportingSalesTicketsPage {...props} />
);

export default ReportingSalesTicketsApp;
